export default __webpack_public_path__ + "static/media/hero.5faeeb29.webm";